import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEAKACardActions = {
  initPeAKACard: ({ commit }, index) => {
    commit('setPeAKACardLock', { index, lock: true })
  },
  peAKACardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        akas: {
          party_id: party.id,
          name: section.name,
          notes: section.notes,
        },
      }).
      then(({ data }) => {
        commit('setPeAKACardLock', { index: 'new', lock: true })
        commit('setPeAKACardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'akas',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peAKACardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/akas/${section.id}`).
      then(({ data }) => {
        commit('setPeAKACardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'akas',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peAKACardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        akas: {
          party_id: party.id,
          name: section.name,
          notes: section.notes,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeAKACardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'akas',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peAKACardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          akas: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const akas = data.akas || []

        commit('setPeAKACardLock', { index, lock: true })
        commit('pePatchParty', {
          akas,
        })
      }).
      catch(handleError)
  },
  peAKACardAddSection: ({ commit }) => {
    commit('setPeAKACardLock', { index: 'new', lock: false })
    commit('addPeAKACardSection', {
      id: null,
      name: '',
      notes: '',
    })
  },
}

export const PEAKACardMutations = {
  setPeAKACardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.AKACard) Vue.set(state.partyEdit.partySections, 'AKACard', {})
    Vue.set(state.partyEdit.partySections.AKACard, index, lock)
  },
  addPeAKACardSection: (state, section) => {
    state.partyEdit.party.akas.push(section)
  },
  peAKACardCreateUndo: state => {
    state.partyEdit.party.akas.pop()
    Vue.set(state.partyEdit.partySections.AKACard, 'new', true)
  },
}

export const PEAKACardGetters = {
  peAKACardLock: state => index => state.partyEdit.partySections.AKACard[index],
  peAKACardHasNewSection: (_, getters) => !!getters.peParty.akas?.find(aka => aka.id === null),
}
